import { Location, NavigateFunction } from "react-router-dom";

import { setToLocalStorage } from "utils";
import { UTILITY_BILL_PAGE } from "./consts";

export const getMuiTableBodyRowProps = (row: any, saveCurrentUrl: () => void, currentUrl: Location, navigate: NavigateFunction, summaryDocumentID: string | null) => ({
  onClick: () => {
    saveCurrentUrl();
    setToLocalStorage("dataEntries", JSON.stringify(row?.row));
    window.sessionStorage.setItem(
      "summaryDocumentID",
      row?.row?.original?.id as any,
    );
    setToLocalStorage(
      "Summary_URL",
      currentUrl.pathname + currentUrl.search,
    );
    setToLocalStorage("type", "Summary");
    navigate(`${UTILITY_BILL_PAGE.ABSOLUTE_PATH(row?.row?.original?.id)}`);
  },
  sx: {
    cursor: "pointer",
    backgroundColor:
      row.row.original.id === summaryDocumentID ? "#DCDCDC" : "",
  },
});
